module.exports = __webpack_public_path__ + "static/media/home.ae4cc87e.png";